module.exports = __webpack_public_path__ + "img/donlogo.e067c518.png";